import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIService } from '../api.service';
import { ReturnObject } from '../../models/returnObject';
import { AccountItem } from '../../models/accountitem';
import { EmployeeListItem } from '../../models/employeelistitem';

@Injectable()
export class EmployeeService {

    constructor(private api: APIService) {
    }

    getEmployeeList(): Observable<ReturnObject<EmployeeListItem[]>> {
        return this.api.getAPI('employee');
    }

    getAccountInfo(): Observable<ReturnObject<AccountItem>> {
        return this.api.getAPINoAccount(`accountinfo`);
    }
}
